namespace GeniuzPOS.Administration {
    export interface UnlockUserRequest extends Serenity.ServiceRequest {
        UserActive?: string;
        Username?: string;
        UserId?: number;
    }
}
